import { ApiService } from './../../services/api/api.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';


import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { LicensedDesignProfessionalSearchComponent } from './components/licensed-design-professional-search.component';
import { AppMaterialComponentsModule } from '../app-material-components/app-material-components.module';
import { UtilityService } from '../../services/utility/utility.service';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
   LicensedDesignProfessionalSearchComponent
  ],
  exports: [
    LicensedDesignProfessionalSearchComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppMaterialComponentsModule,
    FlexModule,
    FlexLayoutModule,
    MatIconModule,
    NgxTrimDirectiveModule
  ],
  providers: [
    ApiService,
    UtilityService  
  ]
})
export class LicensedDesignProfessionalSearchModule { }
